require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-113-updatingyourbillinginformation.json") })
        }
      }, "path---article-113-updatingyourbillinginformation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-113-updatingyourbillinginformation!./.cache/json/article-113-updatingyourbillinginformation.json
// module id = 470
// module chunks = 231608221292675